import { gql } from '@apollo/client'

export const TARGETS_TEMPLATE = gql`
  query GetTargetsTemplates($employeeId: HashedId!) {
    getTargetsTemplates(employeeId: $employeeId) {
      id
      objectiveTitle
      lastModifier {
        id
        firstName
        lastName
        avatarUrl
      }
      lastEditedDate
      creator {
        id
        firstName
        lastName
        avatarUrl
      }
      objectiveKeyResults {
        id
        displayOrder
        text
      }
      objectiveNotes {
        id
        text
        date
        author {
          id
          firstName
          lastName
          avatarUrl
        }
      }
    }
  }
`
